/**
 * Phase 3 - masterUpdate: マスタデータ定期更新ループ
 *
 * phase3 に入ると idle に遷移し、1 時間経過（masterUpdateInterval）または
 * PAGE_NAVIGATED イベントで fetchMasterUpdate を実行する。
 * 成否どちらの場合も idle に戻りループする。
 * XState がステート離脱時にタイマーを自動キャンセルするためメモリリークなし。
 */
export const phase3MasterUpdateConfig = {
  initial: 'idle' as const,
  states: {
    idle: {
      after: { masterUpdateInterval: 'fetching' as const },
      on: {
        PAGE_NAVIGATED: 'fetching' as const,
      },
    },
    fetching: {
      invoke: {
        src: 'fetchMasterUpdate' as const,
        onDone: 'idle' as const,
        onError: 'idle' as const,
      },
    },
  },
}
